import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import $ from "jquery";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { loader_image } from "../_components/Imagepath";
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import AddSupplierPayment from '../rawmaterialsoldessuppliers/AddSupplierPayment';
import { formatDistanceToNow } from 'date-fns';
import Swal from 'sweetalert2';
import {
  Box,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

import EditSupplierPayment from '../rawmaterialsoldessuppliers/EditSupplierPayment';
const SupplierBalanceDetails = () => {
  let { id } = useParams();
  console.log({ id });
  console.log(id);
  const [supplierId, setSupplierId] = useState(null);

  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataSituations, setDataSituations] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showmodelEdit, setshowmodelEdit] = useState(false);
  const [permission, setPermission] = useState({});
  const [showmodel, setshowmodel] = useState(false);
  const [value, setValue] = useState({});
  const [previoussituationdate, setPrevioussituationdate] = useState(null);
  let season_id = localStorage.getItem("season_id");


  const [formData, setFormData] = useState({
    supplier: value.supplier_id,
    season_id: season_id,
    start_date: '',
    end_date: ''
  });
  useEffect(() => {
    setPermission(FindModuleById(201));
    console.log(permission);

    axios
      .get(`/supplier-balances/supplier-list-details-new-server/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supplier_overview);

          setData(response.data.data.Solde);
          setDataa(response.data.data.payemnts_advanced);
          setDataSituations(response.data.data.situations)
          setPrevioussituationdate(response.data.data.previous_situation_date);


        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);


  //   const categoryHandler = () => {
  //     setshowCategory(true)
  // } 
  const handleClose = () => {
    //setshowCategory(false)

    setshowmodel(false);

    setshowmodelEdit(false);
    setSelectedItemId(null)
  }
  const editItem = (item) => {
    // console.log(item);
    // if(item.raw_material_id != 0 && item.id != 0){

    // }else{
    setSelectedItemId(item);
    setshowmodelEdit("showCategory")
    // }

  }

  console.log(previoussituationdate);
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/trader-farmer-supplier-cost/delete-payment/${season_id + '-' + item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                //window.location.href = "/supplier-balances";
                window.location.href = "/supplier-balances-detail/" + value.supplier_id;
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns =
    [

      {
        header: 'Lot Number',
        accessorFn: (row) => `${(row.lot_number) ? row.lot_number : ""} `,
      },

      {
        accessorKey: 'date', //normal accessorKey
        header: 'Date',
      },

      {
        header: "BL Net weight",
        accessorFn: (row) =>
          row.bl_net_weight != null ? numberFormat.format(row.bl_net_weight) : "0.00",
      },
      {
        header: "Decay Net weight",
        accessorFn: (row) =>
          row.decay_net_weight != null
            ? numberFormat.format(row.decay_net_weight)
            : "0.00",
      },
      {
        header: "Raw Material Price",
        accessorFn: (row) =>
          row.price != null ? numberFormat.format(row.price) : "0.00",
      },
      {
        header: "Cost paid by Farmer",
        accessorFn: (row) =>
          row.cost_paid_by_farmer != null
            ? numberFormat.format(row.cost_paid_by_farmer)
            : "0.00",
      },
      {
        header: "Rebate",
        accessorFn: (row) =>
          row.rebate != null ? numberFormat.format(row.rebate) : "0.00",
      },

      {
        accessorKey: 'final_amount', //normal accessorKey
        header: 'final_amount',
      },
    ];

  const columnss =
    [

      {
        accessorKey: 'date', //normal accessorKey
        header: 'Date',
      },
      {
        accessorKey: "cost",
        header: "Amount",
        accessorFn: (row) =>
          row.cost != null
            ? numberFormat.format(row.cost)
            : "0.00",
      },

      // {
      //  // accessorKey: 'cost', //normal accessorKey
      //   header: 'Amount',
      //   accessorFn: (row) => `${(row.cost)?row.cost.toFixed(2):0} `,

      // },
      {
        header: 'Operation Type',
        accessorFn: (row) => `${(row.operationtitle) ? row.operationtitle.title : ""} `,
      },
      {
        header: 'Payment Type',
        accessorFn: (row) => `${(row.paymenttype) ? row.paymenttype.title : ""} `,
      },

      {
        accessorKey: 'note', //normal accessorKey
        header: 'Note',
      },
      {
        header: 'Created At',
        accessorFn: (row) => `${formatDistanceToNow(new Date(row.created_at), { addSuffix: true })}`,
      },
      {
        header: 'Created By',
        accessorFn: (row) => `${(row.createdby) ? row.createdby.first_name + ' ' + row.createdby.last_name : ""} `,
      },
      {
        header: 'Updated At',
        accessorFn: (row) => `${formatDistanceToNow(new Date(row.updated_at), { addSuffix: true })}`,
      },
      {
        header: 'Updated By',
        accessorFn: (row) => `${(row.updatedby) ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ""} `,
      },
    ];



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  // Automatically update the supplier field when `value.supplier` changes
  useEffect(() => {

    if (value && value.supplier_id) {
      setFormData(prevFormData => ({
        ...prevFormData,  // Spread the existing form data (including other fields)
        supplier: value.supplier_id // Update the supplier field
      }));
    }
  }, [value.supplier_id]); // Dependency array ensures this runs only when `value.supplier` changes



  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formData2");
    console.log(formData);

    axios
      .get(`/supplier-balances/supplier-list-details-new-server/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: formData, // Use `params` for GET request data
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supplier_overview);
          setData(response.data.data.Solde);
          setDataa(response.data.data.payemnts_advanced);
          setDataSituations(response.data.data.situations)

        } else {
          // setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
  };



  const downloadPDF = (e) => {
    console.log(e);
    $("#loader-image").removeClass('loader-hide').addClass('loader-show');
    let season_id = localStorage.getItem("season_id");
    axios.get("/supplier-balances/listing-supplier-pdf-new-server", {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      params: { season_id: season_id, supplier: formData.supplier, start_date: formData.start_date, end_date: formData.end_date }
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let supp_name = value.supplier_name ? value.supplier_name : "";
        let startdate = value.start_date ? value.start_date : "";
        let endate = value.end_date ? value.end_date : "";

        link.download = supp_name + ' - ' + startdate + ' - ' + endate + '.pdf';
        link.click();

        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      })
      .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image").removeClass('loader-show').addClass('loader-hide');
      });
  };



  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }

  const downloadExcel = (e) => {
    console.log(e);
    const queryString = objectToQueryString(formData);
    console.log(formData);

    $("#loader-image2").removeClass('loader-hide2');
    $("#loader-image2").addClass('loader-show2');
    window.open(`${base_url}/supplier-balances/listing-supplier-excel-open-new-server?${queryString}`, '_blank');
    $("#loader-image2").addClass('loader-hide2');
    $("#loader-image2").removeClass('loader-show2');
  }

  const addForm = (supplier) => {
    console.log('add');
    console.log(supplier);
    setSupplierId(supplier);
    setshowmodel(true);
  };

  //   const addSupplierSituations = async (id_1) => {
  //     const { value: formValues } = await Swal.fire({
  //       title: 'Add Situation',
  //       html: `
  //       <div style="display: grid;">
  //         <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">Start Date</label>
  //         <input type="date" id="start_date_situation" name="start_date_situation" class="swal2-input" placeholder="Select">

  //         <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">End Date</label>
  //         <input type="date" id="end_date_situation" name="end_date_situation" class="swal2-input" placeholder="Select">
  //       </div>
  //       `,
  //       showCancelButton: true,
  //       confirmButtonText: 'Add Situation',
  //       cancelButtonText: 'Cancel',
  //       customClass: "swal-orders",
  //       preConfirm: () => {
  //         const start_date_situation = document.getElementById('start_date_situation').value;
  //         const end_date_situation = document.getElementById('end_date_situation').value;

  //         if (!start_date_situation) {
  //           Swal.showValidationMessage('Start Date is required');
  //           return null;
  //         }  
  //         if (!end_date_situation) {
  //           Swal.showValidationMessage('End Date is required');
  //           return null;
  //         }
  //         return { id_1, end_date_situation, start_date_situation };
  //       }
  //     });

  //     if (formValues) {
  //       try {
  //         const response = await axios.post(`/supplier-balances/add-situation`, {
  //           supplier: Number(id),
  //           employee_id: formValues.id_1,
  //           start_date_situation: formValues.start_date_situation,
  //           end_date_situation: formValues.end_date_situation,
  //         }, {
  //           headers: {
  //             Authorization: `Bearer ${Authtoken}`,
  //             Apitoken: Apitoken
  //           },
  //         });

  //         if (response.data.code === 200) {
  //           // Close the current modal first
  //           Swal.close();
  //            axios
  //                 .get(`/supplier-balances/all-situation/${Number(id)}`, {
  //                   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //                 })
  //                 .then((response) => {
  //                   console.log(response);
  //                  if (response.data.code === 200) {
  //                     setDataSituations(response.data.data.situations);
  //                   }
  //                 })
  //                 .catch((error) => {
  //                   console.log(error);
  //                 });
  //           // Then show the success message
  //           Swal.fire({
  //             title: 'Success!',
  //             text: 'Supplier Situation addedd Successfully.',
  //             icon: 'success',
  //             timer: 1500, // Auto close after 1.5 seconds
  //             showConfirmButton: false
  //           });
  //         }
  //       } catch (error) {
  //         Swal.fire(
  //           'Error!',
  //           'There was a problem updating Supplier Situation.',
  //           'error'
  //         );
  //       }
  //     }
  // };





  const addSupplierSituations = async (id_1) => {

    let default_start_date = null;
    console.log(previoussituationdate);
    if (previoussituationdate) {
      const prevDate = new Date(previoussituationdate); // convert string → Date
      prevDate.setDate(prevDate.getDate() + 1); // add 1 day
      default_start_date = prevDate.toISOString().split("T")[0]; // format YYYY-MM-DD
    }

    //  <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">Payment Start Date</label>
    //      <input type="date" id="start_date_payment" name="start_date_payment" class="swal2-input" placeholder="Select">

    //      <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;">Payment End Date</label>
    //      <input type="date" id="end_date_payment" name="end_date_payment" class="swal2-input" placeholder="Select"></input>
    const { value: formValues } = await Swal.fire({
      title: 'Add Situation',
      html: `
      <div style="display: grid;">
        <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;"> Start Date</label>
        <input type="date" id="start_date_situation" name="start_date_situation" value="${default_start_date}" class="swal2-input" placeholder="Select">
        
        <label style="text-align: left; padding-left: 6px; margin-bottom: 3px;"> End Date</label>
        <input type="date" id="end_date_situation" name="end_date_situation" class="swal2-input" placeholder="Select">
      </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Add Situation',
      cancelButtonText: 'Cancel',
      customClass: "swal-orders",
      didOpen: () => {
        const startInput = document.getElementById('start_date_situation');
        const endInput = document.getElementById('end_date_situation');

        endInput.addEventListener('change', () => {
          if (startInput.value && endInput.value && new Date(endInput.value) < new Date(startInput.value)) {
            Swal.showValidationMessage(' End Date cannot be earlier than Start Date');
          } else {
            Swal.resetValidationMessage();
          }
        });
      },
      preConfirm: () => {
        const start_date_situation = document.getElementById('start_date_situation').value;
        const end_date_situation = document.getElementById('end_date_situation').value;
        // const start_date_payment = document.getElementById('start_date_payment').value;
        // const end_date_payment = document.getElementById('end_date_payment').value;

        if (!start_date_situation) {
          Swal.showValidationMessage('Start Date is required');
          return null;
        }
        if (!end_date_situation) {
          Swal.showValidationMessage('End Date is required');
          return null;
        }
        // ✅ check if end date is earlier than start date
        if (new Date(end_date_situation) < new Date(start_date_situation)) {
          Swal.showValidationMessage(' End Date cannot be earlier than Start Date');
          return null;
        }
        // if (!start_date_payment) {
        //   Swal.showValidationMessage('Payment Start Date is required');
        //   return null;
        // }  
        // if (!end_date_payment) {
        //   Swal.showValidationMessage('Payment End Date is required');
        //   return null;
        // }
        //return { id_1, end_date_situation, start_date_situation, start_date_payment, end_date_payment };
        return { id_1, end_date_situation, start_date_situation };
      }
    });

    if (formValues) {
      try {
        const response = await axios.post(`/supplier-balances/add-situation`, {
          supplier: Number(id),
          season_id: season_id,
          employee_id: formValues.id_1,
          start_date_situation: formValues.start_date_situation,
          end_date_situation: formValues.end_date_situation,
          // start_date_payment: formValues.start_date_payment,
          // end_date_payment: formValues.end_date_payment,
        }, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          },
        });

        if (response.data.code === 200) {
          // Close the current modal first
          Swal.close();

          axios
            .get(`/supplier-balances/all-situation/${season_id + '-' + Number(id)}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                setDataSituations(response.data.data.situations);
                setPrevioussituationdate(formValues.end_date_situation);
              }
            })
            .catch((error) => {
              console.log(error);
            });
          // Then show the success message
          Swal.fire({
            title: 'Success!',
            text: 'Supplier Situation addedd Successfully.',
            icon: 'success',
            timer: 5000, // Auto close after 1.5 seconds
            showConfirmButton: false
          });
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'There was a problem updating Supplier Situation.',
          'error'
        );
      }
    }
  };

  const refreshDate = async (situation) => {


    $("#loader-image-" + situation.id).removeClass('loader-hide');
    $("#loader-image-" + situation.id).addClass('loader-show');
    try {
      await axios.get(`/supplier-balances/update-situation/${season_id + '-' + situation.id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },

      }).then((response) => {
        console.log(response);
        axios.get(`/supplier-balances/all-situation/${season_id + '-' + Number(id)}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          console.log(response);
          if (response.data.code === 200) {
            setDataSituations(response.data.data.situations);
          }
        }).catch((error) => {
          console.log(error);
        });
        $("#loader-image-" + situation.id).addClass('loader-hide');
        $("#loader-image-" + situation.id).removeClass('loader-show');
      })

    } catch (error) {
      console.error(error);
    }

  }

  // const downloadSituationExcel = () => {
  //   $("#loader-image2").removeClass('loader-hide2');
  //   $("#loader-image2").addClass('loader-show2');
  //   window.open(`${base_url}/supplier-balances/listing-supplier-situation-excel/${Number(id)}`, '_blank');
  //   $("#loader-image2").addClass('loader-hide2');
  //   $("#loader-image2").removeClass('loader-show2');
  // }

  const ActionColumn = ({ row }) => {
    return (
      <div>
        <button
          className="btn btn-primary btn-block"
          id={`button-all-${row.original.id}`}
          onClick={() => refreshDate(row.original)}
        >
          Refresh
          <img
            id={`loader-image-${row.original.id}`}
            className="loader-image loader-hide"
            src={loader_image} // Ensure this is defined
            alt="loading"
          />
        </button>
      </div>
    );
  };

  ActionColumn.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };

  // ✅ Define ActionCell as a separate component
  const ActionCell = ({ row }) => <ActionColumn row={row} />;

  // ✅ Define PropTypes for ActionCell
  ActionCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };






  // const deleteSituationRow = async (row) => {

  //     let season_id = localStorage.getItem("season_id");

  //   Swal.fire({
  //     title: 'Do you really want to delete this record?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'DELETE'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios.get(`/trader-farmer-supplier-cost/delete-situation/${season_id+'-'+row.id}`, {
  //             headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             if (response.data.code === 200) {
  //               Swal.fire(
  //                 'Deleted!',
  //                 'Your Record has been deleted.',
  //                 'success'
  //               );
  //                axios.get(`/supplier-balances/all-situation/${season_id+'-'+Number(id)}`, {
  //                   headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //                 }).then((response) => {
  //                   console.log(response);
  //                 if (response.data.code === 200) {
  //                     setDataSituations(response.data.data.situations);
  //                   }
  //                 }).catch((error) => {
  //                   console.log(error);
  //                 });

  //             }
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           });
  //     }
  //   });


  // }

  // const ActionDeleteSituation = ({ row }) => {
  //   return (
  //     <div>
  //       <button
  //         className="btn btn-danger btn-block"
  //         id={`button-all-${row.original.id}`}
  //         onClick={() => deleteSituationRow(row.original)}
  //       >
  //         delete
  //         <img
  //           id={`loader-image-${row.original.id}`}
  //           className="loader-image loader-hide"
  //           src={loader_image} // Ensure this is defined
  //           alt="loading"
  //         />
  //       </button>
  //     </div>
  //   );
  // };

  // // ✅ Define PropTypes for ActionColumn
  // ActionDeleteSituation.propTypes = {
  //   row: PropTypes.shape({
  //     original: PropTypes.shape({
  //       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  //     }).isRequired,
  //   }).isRequired,
  // };

  // // ✅ Define ActionCell as a separate component
  // const deleteSupplierSituation = ({ row }) => <ActionDeleteSituation row={row} />;

  // // ✅ Define PropTypes for ActionCell
  // deleteSupplierSituation.propTypes = {
  //   row: PropTypes.shape({
  //     original: PropTypes.shape({
  //       id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  //     }).isRequired,
  //   }).isRequired,
  // };



  const DownloadSlip = async (row) => {

    let season_id = localStorage.getItem("season_id");

    $("#loader-image2").removeClass('loader-hide2');
    $("#loader-image2").addClass('loader-show2');
    window.open(`${base_url}/supplier-balances/listing-supplier-situation-pdf/${season_id + '-' + row.id}`, '_blank');
    window.open(`${base_url}/supplier-balances/listing-supplier-situation-excel/${season_id + '-' + row.id}`, '_blank');
    $("#loader-image2").addClass('loader-hide2');
    $("#loader-image2").removeClass('loader-show2');
  }

  const ActionColumnDownload = ({ row }) => {
    return (
      <div>
        <button
          className="btn btn-primary btn-block"
          id={`button-all-${row.original.id}`}
          onClick={() => DownloadSlip(row.original)}
        >
          Download
          <img
            id={`loader-image-${row.original.id}`}
            className="loader-image loader-hide"
            src={loader_image} // Ensure this is defined
            alt="loading"
          />
        </button>
      </div>
    );
  };

  // ✅ Define PropTypes for ActionColumn
  ActionColumnDownload.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };

  // ✅ Define ActionCell as a separate component
  const DownloadSituation = ({ row }) => <ActionColumnDownload row={row} />;

  // ✅ Define PropTypes for ActionCell
  DownloadSituation.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };



  const numberFormat = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });


  const downloadFilehere = async (situation, file_type) => {

    if (file_type == 'pdf') {
      $("#loader-image").removeClass('loader-hide').addClass('loader-show');
      let season_id = localStorage.getItem("season_id");
      axios.get(`${base_url}/supplier-balances/listing-supplier-situation-pdf/${season_id + '-' + situation.id}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          let supp_name = value.supplier_name ? value.supplier_name : "";
          link.download = supp_name + ' Situation ' + situation.auto_id + '.pdf';
          link.click();

          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
        })
        .catch(error => {
          console.error('Error downloading PDF:', error);
          $("#loader-image").removeClass('loader-show').addClass('loader-hide');
        });
    } else {
      let season_id = localStorage.getItem("season_id");

      $("#loader-image2").removeClass('loader-hide2');
      $("#loader-image2").addClass('loader-show2');
      // window.open(`${base_url}/supplier-balances/listing-supplier-situation-pdf/${season_id+'-'+row.id}`, '_blank');
      window.open(`${base_url}/supplier-balances/listing-supplier-situation-excel/${season_id + '-' + situation.id}`, '_blank');
      $("#loader-image2").addClass('loader-hide2');
      $("#loader-image2").removeClass('loader-show2');
    }
    console.log(file_type)
      ;

  }


  const ActionDownloadFile = ({ row }) => {
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-primary btn-block dropdown-toggle me-1"


          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Download
        </button>
        <div className="dropdown-menu">
          <button
            className="dropdown-item btn btn-block btn btn-success"

            onClick={() => downloadFilehere(row.original, 'pdf')}
          >
            PDF
          </button>
          <button

            className="dropdown-item btn btn-block btn btn-success"

            onClick={() => downloadFilehere(row.original, 'excel')}
          >
            Excel
          </button>
        </div>
      </div>
    );
  };

  // ✅ Define PropTypes for ActionColumn
  ActionDownloadFile.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };

  // ✅ Define ActionCell as a separate component
  const DownloadFile = ({ row }) => <ActionDownloadFile row={row} />;

  // ✅ Define PropTypes for ActionCell
  DownloadFile.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }).isRequired,
    }).isRequired,
  };


  const situations_column = [
    {
      header: 'Option',
      Cell: ActionCell, // ✅ Pass the validated component directly
    },
    {
      accessorKey: 'auto_id',
      header: 'ID',
    },
    {
      accessorKey: 'start_date',
      header: ' Start Date',
    },
    {
      accessorKey: 'end_date',
      header: ' End Date',
    },

    {
      accessorKey: "total_bl_net_weight",
      header: "Total BL Net Weight",
      accessorFn: (row) =>
        row.total_bl_net_weight != null
          ? numberFormat.format(row.total_bl_net_weight)
          : "0.00",
    },
    {
      accessorKey: "sum_final_amount",
      header: "Amount Raw Material",
      accessorFn: (row) =>
        row.sum_final_amount != null
          ? numberFormat.format(row.sum_final_amount)
          : "0.00",
    },
    {
      accessorKey: "paid_amount",
      header: "Paid Amount",
      accessorFn: (row) =>
        row.paid_amount != null
          ? numberFormat.format(row.paid_amount)
          : "0.00",
    },
    {
      header: "Solde",
      accessorFn: (row) => {
        if (row.solde) {
          return numberFormat.format(row.solde);
        }
        return "0.00";
      },
    },

    // {
    //   header: 'Download',
    //   Cell: DownloadSituation, // ✅ Pass the validated component directly
    // },

    {
      header: 'Download',
      Cell: DownloadFile, // ✅ Pass the validated component directly

    },

  ];


  //   const editSituation = async (situation) => {
  //   const { value: formValues } = await Swal.fire({
  //     title: 'Edit Situation',
  //     html: `
  //       <div style="display: grid; gap: 8px; text-align: left;">
  //         <label>Reception Start Date</label>
  //         <input type="date" id="start_date_situation" class="swal2-input"
  //                value="${situation.start_date}" />

  //         <label>Reception End Date</label>
  //         <input type="date" id="end_date_situation" class="swal2-input"
  //                value="${situation.end_date}" />

  //         <label>Payment Start Date</label>
  //         <input type="date" id="start_date_payment" class="swal2-input"
  //                value="${situation.start_date_payment || ''}" />

  //         <label>Payment End Date</label>
  //         <input type="date" id="end_date_payment" class="swal2-input"
  //                value="${situation.end_date_payment || ''}" />
  //       </div>
  //     `,
  //     showCancelButton: true,
  //     confirmButtonText: 'Update',
  //     cancelButtonText: 'Cancel',
  //     preConfirm: () => {
  //       const start_date_situation = document.getElementById('start_date_situation').value;
  //       const end_date_situation   = document.getElementById('end_date_situation').value;
  //       const start_date_payment   = document.getElementById('start_date_payment').value;
  //       const end_date_payment     = document.getElementById('end_date_payment').value;

  //       if (!start_date_situation) {
  //         Swal.showValidationMessage('Reception Start Date is required');
  //         return false;
  //       }
  //       if (!end_date_situation) {
  //         Swal.showValidationMessage('Reception End Date is required');
  //         return false;
  //       }
  //       if (!start_date_payment) {
  //         Swal.showValidationMessage('Payment Start Date is required');
  //         return false;
  //       }
  //       if (!end_date_payment) {
  //         Swal.showValidationMessage('Payment End Date is required');
  //         return false;
  //       }

  //       return {
  //         start_date_situation,
  //         end_date_situation,
  //         start_date_payment,
  //         end_date_payment,
  //       };
  //     }
  //   });

  //   if (formValues) {
  //     try {
  //       const response = await axios.post(
  //         `/supplier-balances/edit-update-situation`,
  //         {
  //           id: situation.id,
  //           supplier: situation.supplier,
  //           ...formValues
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${Authtoken}`,
  //             Apitoken
  //           }
  //         }
  //       );

  //       if (response.data.code === 200) {
  //         // Refresh the list
  //         const fresh = await axios.get(
  //           `/supplier-balances/all-situation/${Number(id)}`,
  //           { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } }
  //         );
  //         if (fresh.data.code === 200) {
  //           setDataSituations(fresh.data.data.situations);
  //         }

  //         Swal.fire({
  //           title: 'Saved!',
  //           text: 'Supplier situation updated successfully.',
  //           icon: 'success',
  //           timer: 1500,
  //           showConfirmButton: false
  //         });
  //       }
  //     } catch (error) {
  //       Swal.fire('Error!', 'Problem updating Supplier Situation.', 'error');
  //     }
  //   }
  // };



  //   const deleteSituation = (item) => {
  //     Swal.fire({
  //       title: 'Do you really want to delete this record?',
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'DELETE'
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         axios.get(`/trader-farmer-supplier-cost/delete-situation/${item}`, {
  //               headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //             })
  //             .then((response) => {
  //               console.log(response);
  //               if (response.data.code === 200) {
  //                 Swal.fire(
  //                   'Deleted!',
  //                   'Your Record has been deleted.',
  //                   'success'
  //                 );
  //                 setTimeout(() => {
  //                   //window.location.href = "/supplier-balances";
  //                   window.location.href = "/supplier-balances-detail/"+value.supplier_id;
  //                 }, 500);
  //               }
  //             })
  //             .catch((error) => {
  //               console.log(error);
  //             });
  //       }
  //     });
  //   }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Supplier&apos;s Balance </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplier-balances">Supplier&apos;s Balance</Link>
                    </li>
                    <li className="breadcrumb-item active">Details</li>
                  </ul>
                </div>
                <div className="col-auto">

                  <button onClick={() => addForm(id)} className="btn btn-primary">
                    <i className="fas fa-plus"></i>
                  </button>

                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadPDF()}
                  >
                    <i className="fas fa-file-pdf font-24" ></i>  <img id="loader-image" className="loader-image loader-hide" src={loader_image} />
                  </button>
                  &nbsp;&nbsp;
                  <button
                    className="btn btn-primary"
                    onClick={() => downloadExcel()}
                  >
                    <i className="fas fa-file-excel	font-24"></i> <img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                  </button>




                </div>
              </div>
            </div>

            <div id="filter_inputs_div" className="card filter-card1">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>

                        <input type="hidden" name="supplier" className="form-control" value={formData.supplier} />

                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button> 
                         &nbsp;&nbsp;
                        <a href={`/supplier-balances-detail/${id}`}  className="btn btn-primary me-1" > <i className="fa fa-times"></i></a>
                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Supplier Balance</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Supplier</th>
                        <td className="p-3">
                          {value.supplier_name ? value.supplier_name : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Number Of Receiption</th>
                        <td className="p-3">{value.number_of_receiption}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Start Date</th>
                        <td className="p-3">{value.start_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">End Date</th>
                        <td className="p-3">{value.end_date}</td>
                      </tr>

                      <tr>
                        <th className="p-3">Solde </th>
                        <td className="p-3">{value.sum_final_amount ? value.sum_final_amount : '0.00'} dh</td>
                      </tr>

                      <tr>
                        <th className="p-3">Total Paid</th>
                        <td className="p-3">{value.sum_final_payment_1_2 ? value.sum_final_payment_1_2 : '0.00'} dh</td>
                      </tr>

                      <tr>
                        <th className="p-3">Open Amount</th>
                        <td className="p-3">{value.situation ? value.situation : '0.00'} dh</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total BL Net Weight</th>
                        <td className="p-3">{value.total_bl_net_weight ? value.total_bl_net_weight : '0.00'} KG</td>
                      </tr>


                    </table>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-sm-12">
                <section className="comp-section">
                  <div className="row">

                    <div className="col-md-12">

                      <div className="card bg-white">

                        <div className="card-body">
                          <ul className="nav nav-tabs nav-tabs-bottom">

                            <li className="nav-item">
                              <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Solde</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Payments</a>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link " href="#listing-situation" data-bs-toggle="tab"> Situation</a>
                            </li>
                          </ul>
                          <div className="tab-content">
                            <div className="tab-pane show active" id="listing-groupby">
                              <div className="row" id="listing-followup-groupby" >
                                <div className="col-sm-12" >
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable
                                          columns={columns}
                                          data={data}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          renderRowActionMenuItems={({ row }) => {
                                            if (row.original.lot_number === '') {
                                              console.log("IFFFF");
                                              console.log(row.original);
                                              return [
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>,
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ];
                                            }
                                            return null; // Return null if no actions should be displayed
                                          }}
                                        />

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="listing-all">
                              <div className="row" id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable
                                          columns={columnss}
                                          data={dataa}
                                          enableColumnOrdering
                                          enablePinning
                                          enableRowActions
                                          renderRowActionMenuItems={({ row }) => {
                                            if (row.original.raw_material_id !== 0) {
                                              return [
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ];
                                            } else {
                                              return [
                                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                  Edit
                                                </MenuItem>,
                                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                  Delete
                                                </MenuItem>
                                              ];
                                            }
                                          }}
                                        />

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="tab-pane " id="listing-situation">
                              <div className="row" id="listing-123">
                                <div className="col-sm-12" >
                                  <button onClick={() => addSupplierSituations(5345)} className="btn btn-primary" style={{ 'float': "right" }} >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '1rem',

                                      }}
                                    >

                                      <span>Add Situation </span>
                                    </Box>
                                  </button>
                                </div>
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                      <div className="table-responsive">

                                        <MaterialReactTable
                                          columns={situations_column}
                                          data={dataSituations}
                                          enableColumnOrdering
                                          enablePinning
                                        //  enableRowActions
                                        // renderRowActionMenuItems={({ row }) => {
                                        //    return [
                                        //       <MenuItem key="edit" onClick={() => editSituation(row.original)}>
                                        //         Edit
                                        //       </MenuItem>,
                                        //       <MenuItem key="delete" onClick={() => deleteSituation(row.original.id)}>
                                        //         Delete
                                        //       </MenuItem>
                                        //     ];
                                        // }}
                                        />

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

              </div>
            </div>
          </div>
          {showmodel && (
            // <AddSupplierPayment props={supplierId} handleClose={handleClose} />
            <AddSupplierPayment props={supplierId} show={showmodel} handleClose={handleClose} />
          )}

          <EditSupplierPayment itemId={selectedItemId} show={showmodelEdit} handleClose={handleClose} />

        </div>
      </div>
    </>
  );
};
export default SupplierBalanceDetails;
